import PropTypes from 'prop-types';
import { accountSummaryShape } from 'Workspace/types/account';

const cohortEnrollmentShape = PropTypes.shape({
  cohortId: PropTypes.string,
  enrolledAt: PropTypes.string,
  enrollmentType: PropTypes.string,
  accountSummary: accountSummaryShape,
});

export default cohortEnrollmentShape;
